var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManaAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.60229 7.10356C2.73088 3.96247 5.52092 1.32959 8.04563 0.756067C10.0723 0.296843 11.5439 0.323376 13.1583 1.29081C14.189 1.90719 15.183 2.70114 15.8994 3.67673C16.0749 3.91553 16.9791 3.35629 17.2485 3.242C16.5402 4.78295 15.1381 8.99352 15.1381 8.99352L9.01306 7.1505C9.01306 7.1505 10.9928 6.63209 11.2459 5.65037C11.5378 4.52578 9.7172 3.22567 8.13543 3.43181C6.20057 3.68489 4.3453 5.31565 2.60229 7.10356C5.33315 3.34201 2.60229 7.10356 2.60229 7.10356Z",
    fill: "white",
    fillOpacity: 0.91
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6443 5.53223C19.3833 7.07726 20.4589 10.7572 19.8222 13.2676C19.3099 15.28 18.618 16.5781 17.0219 17.5761C16.0035 18.2129 14.8442 18.7395 13.6502 18.9334C13.3583 18.9803 13.4461 20.0396 13.4236 20.3335C12.3746 19.0028 9.26001 15.8372 9.26001 15.8372L13.6849 11.2205C13.6849 11.2205 13.2461 13.2186 14.0033 13.8921C14.8727 14.6616 16.8586 13.6329 17.3954 12.1308C18.0547 10.2918 17.4444 7.89774 16.6443 5.53223C18.7527 9.67545 16.6443 5.53223 16.6443 5.53223Z",
    fill: "white",
    fillOpacity: 0.91
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0459 18.5332C8.31297 20.0905 4.60244 19.1231 2.77779 17.2903C1.3144 15.8167 0.55311 14.5553 0.516372 12.6756C0.49188 11.4734 0.63679 10.21 1.08377 9.08546C1.19398 8.80992 0.238796 8.34049 0 8.17313C1.68178 7.95475 5.9944 6.90771 5.9944 6.90771L7.68435 13.0756C7.68435 13.0756 6.19442 11.6734 5.22903 11.9775C4.12077 12.3306 3.98402 14.5594 4.9984 15.7922C6.23728 17.3005 8.60483 18.0046 11.0459 18.5332C6.40872 18.2169 11.0459 18.5332 11.0459 18.5332Z",
    fill: "white",
    fillOpacity: 0.91
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManaAddress);
export default __webpack_public_path__ + "static/media/mana-address.0cafdc70d5273a83879f39ed92eb7891.svg";
export { ForwardRef as ReactComponent };